import React, { useState } from 'react';
import { ChevronDown, HelpCircle } from 'lucide-react';

const faqs = [
  {
    question: "Cât costă serviciile unui detectiv particular Bacau?",
    answer: "Costurile serviciilor de detectiv Bacau variază în funcție de complexitatea cazului și durata investigației. Oferim o consultație gratuită inițială pentru evaluarea cazului și stabilirea unui buget personalizat. Prețurile detectivilor particulari Bacau pornesc de la câteva sute de lei pentru verificări simple și pot ajunge la câteva mii pentru investigații complexe în județul Bacău. Contactați-ne la +40 725 040 500 pentru o estimare precisă."
  },
  {
    question: "Sunt legale serviciile de detectiv privat Bacau în România?",
    answer: "Da, detectivii Bacau sunt o agenție licențiată IGPR (Inspectoratul General al Poliției Române). Toate investigațiile detectivului particular Bacau sunt efectuate în conformitate cu legislația română în vigoare. Dovezile obținute sunt admisibile în instanță și respectă normele GDPR privind protecția datelor personale."
  },
  {
    question: "Ce este un test poligraf și cât de precis este detectorul de minciuni Bacău?",
    answer: "Testul poligraf, cunoscut și ca detector de minciuni, măsoară reacțiile fiziologice ale unei persoane (puls, respirație, transpirație) în timpul răspunsurilor la întrebări. Când este administrat de detectivi particulari Bacau cu echipament profesional, precizia poate ajunge la 90-95%. Oferim acest serviciu în Bacău în condiții de maximă confidențialitate."
  },
  {
    question: "Cum pot detecta camere spion sau microfoane ascunse în Bacău?",
    answer: "Echipa de detectivi Bacau folosește echipamente profesionale de scanare RF (radiofrecvență) pentru detectarea tuturor tipurilor de dispozitive de supraveghere: camere video, microfoane, trackere GPS. Detectivul particular Bacau verifică locuințe, birouri, săli de ședințe și vehicule în tot județul Bacău. Serviciul include un raport tehnic detaliat și recomandări de securitate."
  },
  {
    question: "În ce zone din județul Bacău oferiți servicii de detectiv?",
    answer: "Detectivii privați Bacau acoperă întreg județul Bacău cu o rază de acțiune de 50km din centrul orașului. Localitățile principale deservite de detectivul particular Bacau sunt: Bacău, Onești, Moinești, Buhuși, Comănești, Dărmănești, Slănic-Moldova și Târgu Ocna. Suntem disponibili 24/7, inclusiv pentru urgențe în weekend și sărbători."
  },
  {
    question: "Cât durează o investigație de verificare a fidelității cu detectivi Bacau?",
    answer: "Durata variază în funcție de specificul cazului. O investigație tipică a detectivului particular Bacau durează între 3 și 14 zile. În unele situații, detectivii Bacau pot obține dovezi concludente în primele zile, iar în cazuri mai complexe poate fi necesară o perioadă extinsă de supraveghere. Veți primi actualizări regulate despre progresul investigației."
  },
  {
    question: "Ce fel de dovezi pot primi de la un detectiv privat Bacau?",
    answer: "La finalizarea investigației, detectivii particulari Bacau vă vor oferi un dosar complet care poate include: raport detaliat scris, fotografii și materiale video, transcrieri ale conversațiilor relevante, cronologie completă a evenimentelor și, dacă este necesar, declarații pentru instanță. Toate dovezile sunt obținute legal de detectivul Bacau și pot fi folosite în proceduri judiciare."
  },
  {
    question: "Este garantată confidențialitatea investigației cu detectivii Bacau?",
    answer: "Absolut. Confidențialitatea este prioritatea numărul unu pentru detectivii particulari Bacau. Toate informațiile despre caz sunt protejate prin contract de confidențialitate. Detectivul privat Bacau nu divulgă niciodată identitatea clienților sau detaliile investigațiilor. Datele sunt stocate securizat și șterse la cerere după finalizarea cazului."
  }
];

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-20 bg-slate-900" aria-labelledby="faq-heading">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <header className="text-center mb-12">
          <span className="inline-flex items-center gap-2 text-amber-400 font-semibold text-sm uppercase tracking-wider mb-4">
            <HelpCircle className="w-4 h-4" aria-hidden="true" />
            Întrebări Frecvente Detectivi Bacau
          </span>
          <h2 id="faq-heading" className="text-3xl sm:text-4xl font-bold text-white mb-4">
            Întrebări despre Detectiv Particular Bacau
          </h2>
          <p className="text-slate-400 max-w-2xl mx-auto">
            Ai întrebări despre serviciile de detectiv privat Bacau? Găsește răspunsurile aici sau contactează detectivii particulari Bacau pentru o consultație gratuită.
          </p>
        </header>

        {/* FAQ List */}
        <div className="space-y-4" role="list" aria-label="Lista întrebări frecvente">
          {faqs.map((faq, index) => (
            <article 
              key={index}
              className="bg-slate-800/50 border border-slate-700/50 rounded-xl overflow-hidden transition-all duration-300 hover:border-slate-600/50"
              itemScope 
              itemType="https://schema.org/Question"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none focus:ring-2 focus:ring-amber-400/50 rounded-xl"
                aria-expanded={openIndex === index}
                aria-controls={`faq-answer-${index}`}
              >
                <h3 
                  className="text-lg font-semibold text-white pr-4"
                  itemProp="name"
                >
                  {faq.question}
                </h3>
                <ChevronDown 
                  className={`w-5 h-5 text-amber-400 flex-shrink-0 transition-transform duration-300 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                  aria-hidden="true"
                />
              </button>
              
              <div
                id={`faq-answer-${index}`}
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
                itemScope 
                itemType="https://schema.org/Answer"
                itemProp="acceptedAnswer"
                role="region"
                aria-labelledby={`faq-question-${index}`}
              >
                <p 
                  className="px-6 pb-5 text-slate-300 leading-relaxed"
                  itemProp="text"
                >
                  {faq.answer}
                </p>
              </div>
            </article>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-12 text-center">
          <p className="text-slate-400 mb-4">
            Nu ai găsit răspunsul pe care îl cauți despre detectivii Bacau?
          </p>
          <a 
            href="#contact" 
            className="inline-flex items-center gap-2 bg-amber-500 hover:bg-amber-600 text-slate-900 font-semibold px-6 py-3 rounded-lg transition-colors"
          >
            Contactează Detectivii Particulari Bacau
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
